export const pedidos = {
    NOVOATUALIZA: 'NOVOATUALIZA',
    PESQUISA: 'PESQUISA',
    ATUALIZASTATUS: 'ATUALIZASTATUS',
    CHECKOUTSTRIPE: 'CHECKOUTSTRIPE'
}